import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=08f2a94e&scoped=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationDialog.vue?vue&type=style&index=0&id=08f2a94e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f2a94e",
  null
  
)

export default component.exports